export default `p=sin(p+3.*sin(p*.5));
    float s=2., e;
    for(int i=0;i++<5;)
      p=abs(p-1.7)-1.3,
      s*=e=2./min(dot(p,p),1.5),
      p=abs(p)*e-1.;
    return length(p)/s;
  }`